import { render } from "./SearchablesFooter.vue?vue&type=template&id=3f2931a4"
import script from "./SearchablesFooter.vue?vue&type=script&lang=js"
export * from "./SearchablesFooter.vue?vue&type=script&lang=js"

import exportComponent from "/home/node/site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__